import { render, staticRenderFns } from "./AzLaudite.vue?vue&type=template&id=48b3e96e&scoped=true&"
import script from "./AzLaudite.vue?vue&type=script&lang=js&"
export * from "./AzLaudite.vue?vue&type=script&lang=js&"
import style0 from "./AzLaudite.vue?vue&type=style&index=0&id=48b3e96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3e96e",
  null
  
)

export default component.exports